//React
import * as React from "react";
//Material UI
import Box from "@mui/material/Box";
//Components
import TableUsers from "./TableUsers/TableUsers";
import ButtonAddUser from "./ButtonAddUser";
//RTK Query
import { useGetUserListQuery, useGetUserGroupsAvailableQuery } from "../api/apiSlice";

/**
 * User management page, built to NeuraDesigns `userport/index.html`.
 *
 * The group taxonomy is fetched here rather than in the table so the two
 * responses arrive together; it is the same cached query ButtonAddUser and
 * ButtonEditUser already use, so this adds no request.
 */
export default function UsersManagement() {
  const { data: user_data, isSuccess } = useGetUserListQuery();
  const { data: available_user_groups } = useGetUserGroupsAvailableQuery();

  if (!isSuccess) {
    return <></>;
  }

  return (
    <Box
      sx={{
        maxWidth: "var(--container-max)",
        padding: "var(--container-pad-y) var(--container-pad-x) 80px",
        margin: "0 auto",
        "@media (max-width: 720px)": { padding: "18px 14px 56px" },
      }}
    >
      <Box
        sx={{
          marginBottom: "22px",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <Box>
          <Box component="h1" sx={{ fontSize: "1.65rem", fontWeight: 700, letterSpacing: "-0.025em" }}>
            Userport
          </Box>
          <Box
            component="p"
            sx={{
              fontSize: "0.88rem",
              color: "rgba(255, 255, 255, 0.55)",
              marginTop: "4px",
              maxWidth: "680px",
            }}
          >
            Manage who has access to the Neura product suite — add, edit or remove people, and
            control which product-area roles they hold.
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
          <ButtonAddUser />
        </Box>
      </Box>

      <TableUsers
        user_data={user_data.data}
        available_groups={available_user_groups ? available_user_groups.data : undefined}
      />
    </Box>
  );
}
